<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="d-flex a-center py-2">
			<div class="d-flex a-center" style="width: 370px;margin-right: 10px;">
				<div style="font-size: 10px;width: 120px;">发生日期：</div>
				<el-date-picker v-model="times" size="mini" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="d-flex a-center" style="width: 300px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">客户：</div>
				<el-select v-model="search.kh_id" filterable style="width: 50%;" size="mini">
				    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<el-select v-model="search.kh_id" filterable style="width: 50%;margin-left: 10px;" size="mini">
				    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div style="margin-left: auto;" class="d-flex a-center">
				<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
				<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
			</div>
		</div>
		
		
		<div style="height: 72vh;overflow-y: auto;">
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;align-items: center;">
				<div style="width: 40%;">仓库 {{mrck}}</div>
				<div style="width: 40%;font-size: 24px;">库房吞吐量报表</div>
				<div style="width: 20%;"></div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 10px;margin-bottom: 10px;">
				<div style="width: 50%;">发生日期：{{times[0]}} - {{times[1]}}</div>
				<div style="width: 50%;">打印日期：{{today}}</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 15%;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">发生日期</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">货物编号</div>
				<div style="width: 15%;display: flex;justify-content: center; align-items: center;">货物名称</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;flex-flow: column;">
					<div style="border-bottom: 1px solid #000000;width: 100%;text-align: center;">进仓</div>
					<div style="display: flex;width: 100%;">
						<div style="width: 50%;text-align: center;">面积</div>
						<div style="width: 50%;text-align: center;">数量</div>
					</div>
				</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;flex-flow: column;">
					<div style="border-bottom: 1px solid #000000;width: 100%;text-align: center;">出仓</div>
					<div style="display: flex;width: 100%;">
						<div style="width: 50%;text-align: center;">面积</div>
						<div style="width: 50%;text-align: center;">数量</div>
					</div>
				</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;flex-flow: column;">
					<div style="border-bottom: 1px solid #000000;width: 100%;text-align: center;">库存</div>
					<div style="display: flex;width: 100%;">
						<div style="width: 50%;text-align: center;">面积</div>
						<div style="width: 50%;text-align: center;">数量</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in sjlist">
				<div style="width: 15%;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">{{item.create_time}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.bh}}</div>
				<div style="width: 15%;display: flex;justify-content: center; align-items: center;">{{item.hwmx == null ? '' : item.hwmx.hwmc}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;flex-flow: column;">
					<div style="display: flex;width: 100%;">
						<div style="width: 50%;text-align: center;">{{item.rc}}</div>
						<div style="width: 50%;text-align: center;">{{item.rc == 0 ? 0 : item.mj}}</div>
					</div>
				</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;flex-flow: column;">
					<div style="display: flex;width: 100%;">
						<div style="width: 50%;text-align: center;">{{item.cc}}</div>
						<div style="width: 50%;text-align: center;">{{item.cc == 0 ? 0 : item.mj}}</div>
					</div>
				</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;flex-flow: column;">
					<div style="display: flex;width: 100%;">
						<div style="width: 50%;text-align: center;">{{item.hwmx == null ? '' : item.hwmx.js}}</div>
						<div style="width: 50%;text-align: center;">{{item.hwmx == null ? '' : item.hwmx.mj}}</div>
					</div>
				</div>
			</div>
		</div>
		
		
		<!-- 打印模板 -->
		<!-- <div class="print-div none" id="print_area" media="print">
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 40%;"></div>
				<div style="width: 40%;font-size: 24px;">代付运费单</div>
				<div style="width: 20%;">{{dydd.hyfsdata.name}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 30%;">客户名称：{{dydd.khdata.name}}</div>
				<div style="width: 20%;">简称：{{dydd.khdata.j_name}}</div>
				<div style="width: 25%;">代付日期：{{dydd.qrhk_time}}</div>
				<div style="width: 25%;">单号：{{dydd.bh}}</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">供货方</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">货物名称</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">件数</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">运费金额(元)</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">备注</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in dydd.djglhw">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">{{item.ghs}}</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">{{item.hwmc}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.num}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.yf}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.desc}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 33%;">合计件数：{{dydd.hjjs}}</div>
				<div style="width: 33%;">大写：{{dydd.jedx}}</div>
				<div style="width: 33%;">合计金额：<span style="margin-right: 4px;">{{dydd.zje}}</span>元</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 34%;display: flex;font-size: 13px;margin-bottom: 4px;">广州诚晖冷冻食品物流有限公司</div>
				<div style="width: 66%;display: flex;font-size: 13px;">电话：0757-85709188，85709200，85709201，17708636608</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;">
				<div style="width: 33%;">制单：{{dydd.cjrdata.name}}</div>
				<div style="width: 33%;">收款人：</div>
				<div style="width: 33%;">车牌号：</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	components: {
		buttonSearch
	},
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			khlist:[],
			times:'',
			search:{
				kh_id: ''
			},
			sjlist:[],
			today:''
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.axios.get('/admin/khxxs', { token: true }).then(res => {
			this.khlist = res.data.data;
		});
		const moment = require('moment');
		const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
		this.today = currentTime
	},
	methods: {
		// 清空筛选条件
		clearSearch() {
			this.search = {
				kh_id: '',
			};
			this.times = ''
		},
		// 搜索事件
		searchEvent() {
			let data = {
				ks_time:this.times[0],
				js_time:this.times[1],
				kh_id:this.search.kh_id
			}
			this.axios.post('/admin/bb/khcrmxb', data, {
				token: true
			}).then(res => {
				this.sjlist = res.data.data
			})
		},
		
	}
};
</script>

<style>
	.container {
	  width: 400px;
	  height: 300px;
	  margin: 30px auto;
	  box-shadow: 0 0 2px gray;
	  padding: 20px;
	  overflow: scroll; 
	}
	
	.scroll {
	  width: 1400px;
	  height: 1300px;
	}
	
	.container::-webkit-scrollbar {
	  width: 10px;
	  height: 10px;
	}
	
	.container::-webkit-scrollbar-thumb {
	  background: linear-gradient(to bottom right, #4d7fff 0%, #1a56ff 100%);
	  border-radius: 5px;
	}
	
	.container::-webkit-scrollbar-track {
	  background-color: #ddd;
	  border: 1px solid #ccc;
	}
	
	.container::-webkit-scrollbar-button {
	  background-color: #4d7fff;
	  border-radius: 5px;
	}
	
	.container::-webkit-scrollbar-button:hover {
	  background-color: #999999;
	}
</style>
